export function rewriteSession() {
  const originalSetItem = window.sessionStorage.setItem;

  window.sessionStorage.setItem = function (key, newValue) {
    const setItemEvent = new Event('setItemEvent');

    setItemEvent.key = key;
    setItemEvent.newValue = newValue;

    window.dispatchEvent(setItemEvent);

    originalSetItem.apply(this, arguments);
  };
}
